import { getPasswordStrengthActionCreator, resetPasswordStrengthActionCreator } from 'actions/authActions'
import { connect } from 'react-redux'
import { StoreDispatch } from 'interfaces/component'
import withPasswordStrength from 'components/atoms/inputs/withPasswordStrength'
import PasswordField, { PasswordFieldDispatchProps, PasswordFieldOwnProps } from 'components/features/pfm/PasswordField/PasswordField'

const mapDispatchToProps = (dispatch: StoreDispatch) => ({
  getPasswordStrength: (password: string) => dispatch(getPasswordStrengthActionCreator.request(password)),
  resetPasswordStrength: () => dispatch(resetPasswordStrengthActionCreator()),
})

const PasswordFieldContainerInner = withPasswordStrength(PasswordField)

const PasswordFieldContainer = connect<
  {},
  PasswordFieldDispatchProps,
  PasswordFieldOwnProps
>(undefined, mapDispatchToProps)(PasswordFieldContainerInner)


export default PasswordFieldContainer
